// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { FoldVertical as RawFoldVertical } from "lucide-react";
export const FoldVertical = /* @__PURE__ */ createIcon(RawFoldVertical, "FoldVertical", 2);
